import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Box,
    Button,
    AppBar,
    Toolbar,
    Grid,
    Typography,
    Modal,
    LinearProgress,
    TextField,
    Tooltip,
    CircularProgress, IconButton
} from '@mui/material';
import HeaderAvatar from "./HeaderAvatar";
import {
    addChapter, addSlidesToChapter,
    addSlideToChapter,
    createVideoFolder, deletePDF, deletePDFFolder, deleteSlide,
    getChapters,
    getSlides,
    processProject, processZipProject,
    reorderChapterSlides,
    updateSlide
} from '../services/api';
import Icon from "./Icon";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragEndEvent } from '@dnd-kit/core';
import ChapterBox from '../components/ChapterBox';
import { deleteChapterSlide } from '../services/api';
import {DragOverlay } from '@dnd-kit/core';
import { restrictToWindowEdges } from '@dnd-kit/modifiers';
import {
    Add, Delete
} from '@mui/icons-material';
import {Slide} from '../services/types'

import SlideEditModal from '../components/SlideEditModal'

interface Presentation {
    id: string;
    name: string;
    photo_url: string;
    clm_type_id: string;
}
interface ChapterSlide {
    id: string;
    slide: Slide;
}
interface Chapter {
    id: string;
    name: string;
    project_id: string;
    sort: number;
    external_id?: string;
    slides: ChapterSlide[];
}
interface PresentationEditorProps {
    presentation: Presentation;
    onUpload: (file: File) => Promise<void>;
}
interface DeleteConfirmationModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    item: Slide | null
}

// interface ChapterBoxProps {
//     chapter: Chapter;
//     onAddSlide: (chapterId: string) => void;
// }
// interface SortableSlideItemProps {
//     slide: ChapterSlide;
// }
const PresentationEditor: React.FC<PresentationEditorProps> = ({ presentation, onUpload }) => {
    const fileInputRef = React.useRef<HTMLInputElement>(null);
    const [slides, setSlides] = useState<Slide[]>([]);
    const [chapters, setChapters] = useState<Chapter[]>([]);
    const [selectAddChapter, setSelectAddChapter] = useState<string>('');
    const [errorSlide, setErrorSlide] = useState<string>('');
    const [isProcessModalOpen, setProcessModalOpen] = useState(false);
    const [isChapterCreateModalOpen, setIsChapterCreateModalOpen] = useState(false);
    const [createChapterName, setCreateChapterName] = useState('');
    const [isSlideSelectionModalOpen, setIsSlideSelectionModalOpen] = useState(false);
    const [onSlideSelect, setOnSlideSelect] = useState<(slideId: string) => void>(() => {});
    const [isSlideEditModalOpen, setIsSlideEditModalOpen] = useState(false);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
    const [selectedSlide, setSelectedSlide] = useState<Slide | null>(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState<Slide | null>(null);
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);


    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const fetchSlidesAndChapters = async () => {
        try {
            const response = await getSlides(presentation.id);
            setSlides(response.items);
            const responseChapters = await getChapters(presentation.id);
            setChapters(responseChapters.items);
            setLoading(false)
            setUpdating(false)
        } catch (error) {
            console.error('Error fetching slides:', error);
        }
    };
    const fetchSlides = async () => {
        try {
            const response = await getSlides(presentation.id);
            setSlides(response.items);
            setLoading(false)
            setUpdating(false)

            // if (chapters.length > 0){
            //     setLoading(false)
            // }
        } catch (error) {
            console.error('Error fetching slides:', error);
        }
    };
    const fetchChapters = async () => {
        try {
            const response = await getChapters(presentation.id);
            setChapters(response.items);
            // if (slides.length > 0){
            //     setLoading(false)
            // }
        } catch (error) {
            console.error('Error fetching slides:', error);
            // setChapters([]);
        }
    };
    useEffect(() => {
        fetchSlidesAndChapters();
        // fetchChapters()
    }, [presentation.id]);

    const handleCreateChapter = async () => {

        try {
            const cchapter = {
                name: createChapterName,
                project_id: presentation.id,
                sort: 1,
                external_id: ''
            }
            await addChapter(cchapter);
            fetchSlides();
            fetchChapters()
            setIsChapterCreateModalOpen(false)
        } catch (error) {
            console.error('Error creating folder:', error);
        }

    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            onUpload(file);
        }
    };

    // const SortableSlideItem: React.FC<SortableSlideItemProps> = ({ slide }) => {
    //     const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: slide.id });
    //
    //     const style = {
    //         transform: CSS.Transform.toString(transform),
    //         transition,
    //     };
    //
    //     return (
    //         <Box
    //             ref={setNodeRef}
    //             style={style}
    //             {...attributes}
    //             {...listeners}
    //             className='chapterSlideItem'
    //         >
    //             <img src={slide.slide.preview} alt={slide.slide.name} />
    //         </Box>
    //     );
    // };

    // const ChapterBox: React.FC<ChapterBoxProps> = ({ chapter, onAddSlide, onReorderSlides }) => {
    //     const sensors = useSensors(
    //         useSensor(PointerSensor),
    //         useSensor(KeyboardSensor, {
    //             coordinateGetter: sortableKeyboardCoordinates,
    //         })
    //     );
    //
    //     const handleDragEnd = (event: DragEndEvent) => {
    //         const { active, over } = event;
    //
    //         if (over && active.id !== over.id) {
    //             const oldIndex = chapter.slides.findIndex((slide) => slide.id === active.id);
    //             const newIndex = chapter.slides.findIndex((slide) => slide.id === over.id);
    //             const newOrder = arrayMove(chapter.slides, oldIndex, newIndex);
    //             onReorderSlides(chapter.id, newOrder.map(slide => slide.id));
    //         }
    //     };

    //     return (
    //         <Box mb={4} sx={{pr: '12px'}}>
    //             <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1}}>
    //                 <Typography variant="h6">{chapter.name}</Typography>
    //                 <Button sx={{color: '#3a485b', display: 'flex', gap: '4px'}} onClick={() => onAddSlide(chapter.id)}>
    //                     <Add /> Добавить слайд
    //                 </Button>
    //             </Box>
    //             <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
    //                 <SortableContext items={chapter.slides.map(slide => slide.id)} strategy={verticalListSortingStrategy}>
    //                     <Box className='chapterSlideItems'>
    //                         {chapter.slides.map((slideItem) => (
    //                             <SortableSlideItem key={slideItem.id} slide={slideItem} />
    //                         ))}
    //                     </Box>
    //                 </SortableContext>
    //             </DndContext>
    //         </Box>
    //     );
    // };

    const handleReorderSlides = async (chapterId: string, newOrder: string[]) => {
        try {
            await reorderChapterSlides(chapterId, newOrder);
            // Update the local state to reflect the new order
            setChapters(prevChapters => prevChapters.map(chapter =>
                chapter.id === chapterId
                    ? {
                        ...chapter,
                        slides: newOrder.map(id => chapter.slides.find(slide => slide.id === id))
                            .filter((slide): slide is ChapterSlide => slide !== undefined)
                    }
                    : chapter
            ));
        } catch (error) {
            console.error('Error reordering slides:', error);
        }
    };


    const handleAddSlideModal = async (chapterId:string) => {
        setIsSlideSelectionModalOpen(true);
        setSelectAddChapter(chapterId)
    };


    const handleDeleteSlide = async (chapterSlideId: string) => {
        try {
            await deleteChapterSlide(chapterSlideId);
            // Update the chapters state after successful deletion
            // setChapters(prevChapters => prevChapters.map(chapter =>
            //     chapter.id === chapterSlideId
            //         ? { ...chapter, slides: chapter.slides.filter(slide => slide.id !== slideId) }
            //         : chapter
            // ));
            fetchChapters()
        } catch (error) {
            console.error('Error deleting slide:', error);
            // Handle error (e.g., show an error message to the user)
        }
    };

    const handleEditSlide = async (chapterSlide: Slide) => {
        try {
            handleSlideClick(chapterSlide)
        } catch (error) {
            console.error('Error deleting slide:', error);
            // Handle error (e.g., show an error message to the user)
        }
    };

    const handleAddSlideToChapter = async (slideId: string) => {
        setIsSlideSelectionModalOpen(false);
        try {
            await addSlideToChapter(selectAddChapter, slideId);
            const updatedChapters = await getChapters(presentation.id);
            fetchChapters()
        } catch (error) {
            console.error('Error adding slide to chapter:', error);
        }
    };

    const handleUpdateSlide = async (updatedSlide: Slide) => {
        try {
            setUpdating(true)
            console.log(updatedSlide)
            await updateSlide(updatedSlide.id, {
                title: updatedSlide.title,
                description: updatedSlide.description,
                duration: updatedSlide.duration,
                external_id: updatedSlide.external_id,
                category: updatedSlide.category,
                detailing: updatedSlide.detailing,
                product_id: updatedSlide.product_id,
            });
            fetchSlides();
        } catch (error) {
            console.error('Error updating slide:', error);
        }
    };



    // const SlideItem: React.FC<SlideItemProps> = ({ slide }) => {
    //     const { attributes, listeners, setNodeRef, transform } = useDraggable({
    //         id: slide.id,
    //         data: { type: 'slide', slide },
    //     });
    //
    //     const handleSlideClick = () => {
    //         setSelectedSlide(slide);
    //         setIsSlideEditModalOpen(true);
    //     };
    //
    //     return (
    //         // <Box
    //         //     ref={setNodeRef}
    //         //     {...attributes}
    //         //     {...listeners}
    //         //     className='slideItem'
    //         //     onClick={handleSlideClick}
    //         // >
    //         //     <img src={slide.preview} alt={slide.name} />
    //         //     <Box className='slideItemText'>{slide.name}</Box>
    //         // </Box>
    //         <Box className='slideItem' key={slide.id}>
    //             {slide.preview ?
    //                 <Box>
    //                     <img src={slide.preview} alt={slide.name}/>
    //                 </Box>
    //                 : null}
    //             <Box className='slideItemText'>
    //                 {slide.name}
    //             </Box>
    //         </Box>
    //     );
    // };

    const handleSlideClick = (slide: Slide) => {
        setSelectedSlide(slide as Slide);
        setIsSlideEditModalOpen(true);
    };

    const handleZipCreate = async () => {
        setProcessModalOpen(true)
        var data = await processZipProject(presentation.id)
        window.open(data.archive_path, '_blank');
        setProcessModalOpen(false)
    };
    const handleGenerateClick = async () => {
        setProcessModalOpen(true)
        // await processProject(presentation.id)

        try {
            await processProject(presentation.id);
        } catch (error: any) {
            if (error.message.includes('500')) {
                setErrorSlide(error.response.data.detail)
                setIsErrorModalOpen(true)
            }
        } finally {
            setProcessModalOpen(false);
        }

        // setProcessModalOpen(false)
    };
    const handleOpenLink = () => {
        window.open('https://app.productscript.ru/'+presentation.id+'/', '_blank');
    };

    const handleDownloadLink = () => {
        window.open('https://static.productscript.ru/uploads/archives/'+presentation.id+'/source.zip', '_blank');
    };

    const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ open, onClose, onConfirm, item }) => (
        <Box sx={{ /* стили */ }}>
            <Typography>Вы уверены, что хотите удалить этот слайд?</Typography>
            <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                <Button className="blueModalButton" variant="contained" onClick={onConfirm}>
                    Удалить
                </Button>
                <Button className="blueModalButton" variant="outlined" onClick={onClose} style={{color: 'red', borderColor: 'red'}}>
                    Отмена
                </Button>
            </Box>
        </Box>
    );
    const handleAddAllSlides = async (chapterId: string) => {
        var allslides: string[] = []
        slides.forEach(slide => {
            allslides.push(slide.id)
        });
        await addSlidesToChapter(chapterId, allslides);
        fetchChapters()
    };
    const handleDeletePrompt = (item: Slide) => {
        setItemToDelete({ ...item });
        setIsDeleteModalOpen(true);
    };
    const handleDelete = async () => {
        if (itemToDelete) {
            try {
                // console.log(itemToDelete.id)
                await deleteSlide(itemToDelete.id);
                fetchSlides();
            } catch (error) {
                console.error('Error deleting item:', error);
            } finally {
                setIsDeleteModalOpen(false);
                setItemToDelete(null);
            }
        }
    };

    return (
        <Box display="flex" sx={{height: 'calc(100vh - 64px)'}}>
            {!loading && (
                <>
                    <Box sx={{display: 'flex', flexDirection: 'column', width: '284px', height: '100%', background: '#3a485b36', boxSizing: 'border-box'}}>
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            accept=".zip"
                        />
                        <Box sx={{ mt: 2, display:'flex', justifyContent: 'center'}}>
                            <Tooltip title="Загрузить ZIP" placement="bottom" arrow>
                                <Button sx={{color: '#3a485b', display: 'flex', gap: '3px', minWidth: '54px', padding: 0}} onClick={handleUploadClick}><Icon name="upload"/></Button>
                            </Tooltip>
                            <Tooltip title="Сгенерировать презентацию" placement="bottom" arrow>
                                <Button sx={{color: '#3a485b', display: 'flex', gap: '4px', minWidth: '54px', padding: 0}} onClick={handleGenerateClick}><Icon name="generate"/></Button>
                            </Tooltip>
                            <Tooltip title="Скачать архив" placement="bottom" arrow>
                                <Button sx={{color: '#3a485b', display: 'flex', gap: '4px', minWidth: '54px', padding: 0}} onClick={handleDownloadLink}><Icon name="download"/></Button>
                            </Tooltip>
                            <Tooltip title="Открыть ссылку" placement="bottom" arrow>
                                <Button sx={{color: '#3a485b', display: 'flex', gap: '4px', minWidth: '54px', padding: 0}} onClick={handleOpenLink}><Icon name="source"/></Button>
                            </Tooltip>
                            <Tooltip title="Архив ELMA" placement="bottom" arrow>
                                <Button sx={{color: '#3a485b', display: 'flex', gap: '4px', minWidth: '54px', padding: 0}} onClick={handleZipCreate}>ZIP</Button>
                            </Tooltip>
                        </Box>
                        <Box className='slideItems' sx={{display: 'block'}}>
                            {slides.map((slide) => (
                                <Box className='slideItem' sx={{m: '20px auto', width: '240px', '&:hover .deleteButton': {opacity: 1}}} key={slide.id} onClick={() => handleSlideClick(slide)}>
                                    {slide.preview ?
                                        <Box>
                                            <img src={slide.preview} alt={slide.name}/>
                                        </Box>
                                        : null}
                                    <Box className='slideItemText'>
                                        {slide.name}
                                    </Box>

                                    <IconButton
                                        className="deleteButton"
                                        sx={{
                                            position: 'absolute',
                                            top: 5,
                                            right: 5,
                                            opacity: 0,
                                            transition: 'opacity 0.2s',
                                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                            '&:hover': {backgroundColor: 'rgba(255, 255, 255, 0.9)'}
                                        }}
                                        onClick={(e) => {e.stopPropagation(); handleDeletePrompt(slide)}}
                                        // onClick={handleDelete}
                                    >
                                        <Delete/>
                                    </IconButton>
                                </Box>
                            ))}
                        </Box>
                    </Box>

                    <Box className={!isSlideEditModalOpen ? "presentationRightContainer" : "presentationRightContainerNoScroll"}>
                        {!isSlideEditModalOpen ?
                            <Box sx={{width: 'calc(100% - 24px)'}} p={2}>
                                {Array.isArray(chapters) && chapters.map((chapter) => (
                                    // <ChapterBox key={chapter.id} chapter={chapter} onAddSlide={()=>handleAddSlideModal(chapter.id)} />
                                    <ChapterBox
                                        key={chapter.id}
                                        chapter={chapter}
                                        onAddSlide={handleAddSlideModal}
                                        onAddAllSlide={handleAddAllSlides}
                                        onReorderSlides={handleReorderSlides}
                                        onDeleteSlide={handleDeleteSlide}
                                        onEditSlide={handleEditSlide}
                                    />
                                ))}
                                <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                    <Button sx={{color: '#3a485b', display: 'flex', gap: '4px'}}
                                            onClick={() => setIsChapterCreateModalOpen(true)}><Add/> Добавить главу</Button>
                                </Box>
                            </Box>
                            :
                            <Box sx={{width: 'calc(100% - 24px)'}}>
                                <SlideEditModal
                                    slide={selectedSlide}
                                    isOpen={isSlideEditModalOpen}
                                    onClose={() => setIsSlideEditModalOpen(false)}
                                    onSave={handleUpdateSlide}
                                    presentationType={presentation.clm_type_id}
                                />
                            </Box>
                        }
                    </Box>
                </>
            )}

            {loading && (
                <Box className='notFoundElements'>
                    <CircularProgress/>
                </Box>
            )}

            {updating && (
                <Box className='notFoundElements' sx={{backgroundColor: 'rgba(0, 0, 0, 0.6)'}}>
                    <Box sx={{p:3, backgroundColor:'white', borderRadius: '10px'}}>
                        <CircularProgress/>
                    </Box>
                </Box>
            )}

            {/* Модальное окно создания главы */}
            <Modal open={isChapterCreateModalOpen} onClose={() => setIsChapterCreateModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600, minWidth: 300 }}>
                        <Typography variant="h6">Добавить главу</Typography>
                        <TextField
                            label="Название"
                            value={createChapterName}
                            onChange={(e) => setCreateChapterName(e.target.value)}
                            fullWidth
                            type="text"
                            margin="normal"
                        />
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={handleCreateChapter}>
                                Добавить
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsChapterCreateModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Модальное окно выбора слайда */}
            <Modal open={isSlideSelectionModalOpen} onClose={() => setIsSlideSelectionModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center', overflowY: 'scroll'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600, minWidth: 300, maxHeight:'90vh', overflow: 'scroll' }}>
                        <Box className='addModalSlideItems'>
                            {slides.map((slide) => (
                                <Box className='addModalSlideItem' key={slide.id} onClick={()=>handleAddSlideToChapter(slide.id)}>
                                    <img src={slide.preview} alt={slide.name}/>
                                </Box>
                            ))}
                        </Box>
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Box></Box>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsSlideSelectionModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Modal open={isProcessModalOpen}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Box sx={{ /* стили */ }}>
                            <Typography sx={{mb: 3}}>Идет обработка</Typography>
                            <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                <CircularProgress style={{color: '#3a485b'}}/>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Modal open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 360 }}>
                        <DeleteConfirmationModal
                            open={isDeleteModalOpen}
                            onClose={() => setIsDeleteModalOpen(false)}
                            onConfirm={handleDelete}
                            item={itemToDelete}
                        />
                    </Box>
                </Box>
            </Modal>

            <Modal open={isErrorModalOpen} onClose={() => setIsErrorModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 360 }}>
                        <Box className='addModalSlideItems'>
                            Произошла ошибка в слайде {errorSlide}. Проверьте в нем прописанные модальне окна и если есть пустые попапы, добавьте в них что-то и потом удалите. Это решит проблему со слайдом!
                        </Box>
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Box></Box>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsErrorModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Закрыть
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};
export default PresentationEditor;
